module.exports = __webpack_public_path__ + "static/media/Avatars_Female-07.17540e76.png";